module.exports = __webpack_public_path__ + "img/logo-sbb.c8db4dda.png";